/* global axios */
import ApiClient from './ApiClient';

class InboxSalesforceAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getConfig(inboxId) {
    return axios.get(`${this.url}/${inboxId}/salesforce_configuration`);
  }

  updateConfig(inboxId, payload) {
    return axios.patch(
      `${this.url}/${inboxId}/salesforce_configuration`,
      payload
    );
  }
}

export default new InboxSalesforceAPI();
